import { Accordion, FormControl, FormGroup, Select } from '@mui/material'
import { styled } from '@mui/material/styles'

export const StyledFormGroup = styled(FormGroup)({
  display: 'flex',
  flexDirection: 'column',
  gap: 25,
})

export const InputLabel = styled('label')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '12px',
  color: theme.palette.text.secondary,
}))

export const Placeholder = styled('span')(({ theme }) => ({
  fontWeight: 400,
  fontSize: '16px',
  color: theme.palette.text.secondary,
}))

export const SelectField = styled(Select)({
  '&.MuiInput-root': {
    marginTop: 8,
  },
})

export const SubTasksWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 15,
  h4: {
    fontWeight: 500,
    fontSize: '16px',
    color: theme.palette.common.black,
  },
}))

export const TaskActionBtnWrapper = styled('div')(({ theme }) => ({
  padding: '10px 0px',
  width: '100%',
  background: theme.palette.common.white,
  div: {
    display: 'inline-block',
    float: 'right',
  },
}))

export const Wrapper = styled('div')({
  paddingBottom: 10,
})

export const AddSubTaskWrapper = styled(Accordion)(({ theme }) => ({
  marginBottom: '10px',
  boxShadow: 'none',
  '& .MuiCollapse-root': {
    border: `1px solid ${theme.palette.divider}`, //#B0B7C3
    borderTop: 0,
    marginBottom: '10px',
    borderBottomLeftRadius: '4px',
    borderBottomRightRadius: '4px',
  },
  '& .MuiAccordionSummary-root': {
    background: theme.palette.grey[100], //'#F5F5F5'
    boxShadow: 'none',
    padding: '8px',
    borderTopRightRadius: '4px',
    borderTopLeftRadius: '4px',
    maxHeight: '50px',
    color: theme.palette.text.primary, //'#0F1222'
    '& .MuiAccordionSummary-content': {
      display: 'block',
    },
    '&.Mui-expanded': {
      padding: '8px',
      background: theme.palette.common.white,
      border: `1px solid ${theme.palette.divider}`,
      minHeight: '10px',
      borderBottom: 0,
    },
  },
  '& .MuiAccordionDetails-root': {
    display: 'flex',
    flexDirection: 'column',
    gap: 15,
  },
}))

export const SubTaskBtnWrapper = styled('div')({
  marginTop: 10,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: 'auto',
  gap: 10,
})

export const AssignedToForm = styled(FormControl)({
  '.menu': {
    height: '200px',
  },
})
